import React, { useState, useEffect, useRef, } from 'react'
import { useLocation, } from 'react-router-dom'
import ReCAPTCHA from 'react-google-recaptcha';
import parse from 'html-react-parser';

import useAuth from '../../auth/UseAuth';

import { GlobalFormats } from '../../classess/main/globalFormats';
import { LoginRequest } from '../../classess/account/loginRequest';
import { User } from '../../classess/user/user';
import { Toast } from '../../classess/notifications/toast';
import { NotificationToast, } from '../../classess/main/notifications/notificationToast';

import {
    getResponse, settings, isValidEmail, styles, handleResponseMessageAsync, isUndNullEmp, getLanguageObj, notificationsToastGetAsync,
    notificationsToastShowAsync, LoadingSection
} from '../../helpers/main';
import Menu from '../main/Menu';

// const $ = window.jqGlobal || window.jQuery;

const { app, backend, icons, images, labels, messages, } = settings;

const currentMethod = 'Login';

export default function Login({
    languageObj = GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
}) {
    //#region variables
    let dataRequest = {};
    const auth = useAuth();
    //const navigate = useNavigate();
    const location = useLocation();
    // const history = useHistory();
    const locationStateFrom = location.state?.from;
    const localStorageRedirectUrl = localStorage.getItem(settings.localStorage.redirectId);
    let previusObjUrl = !isUndNullEmp({ data: locationStateFrom, subMethod: 'Login - checkPreviusState' })?.result ? locationStateFrom : null;

    if (!previusObjUrl && !isUndNullEmp({ data: localStorageRedirectUrl, subMethod: 'Login - checkPreviusLocalStorage' })?.result) {
        previusObjUrl = localStorageRedirectUrl;
    }

    const urlStop = '#nothing';
    const [showData, setShowData] = useState(true);
    const [process, setProcess] = useState({ showLoading: true, login: false });

    const [dataForm, setDataForm] = useState(LoginRequest?.getClass());
    const [dataFormLength] = useState(User?.minMaxLength(false));
    const [errors, setErrors] = useState({ email: '', password: '' });
    const [showPassword, setShowPassword] = useState(false);
    const isMount = useRef(true);

    const controls = {
        buttons: {
            home: {
                defaultClass: 'btn btn-light border shadow-sm font-weight-bold text-secondary mx-1 px-4',
                id: 'btnHome',
            },
            login: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4',
                id: 'btnLogin',
            },
        },
        checkBox: {
            remenberMe: {
                attributes: {
                },
                id: 'chkRemenberMe',
            },
        },
        icons: {
            login: {
                id: 'iconLogin',
                defaultClass: icons?.powerOff,
            },
        },
        inputs: {
            email: {
                id: 'inputEmail',
            },
            password: {
                id: 'inputPassword',
            },
        },
        spiners: {
            login: {
                id: 'spLogin',
                defaultClass: '',
            }
        },
        urls: {
            forgotYourPassword: {
                id: 'urlForgotYourPassword',
                defaultClass: 'btn-link',
            },
            reCaptchaPrivaciConditions: {
                id: 'urlReCaptchaPrivaciConditions',
                defaultClass: '',
            },
            requestAccount: {
                id: 'urlRequestAccount',
                defaultClass: '',
            },
            requestAccountMonitor: {
                id: 'urlRequestAccountMonitor',
                defaultClass: '',
            },
        },
    };

    const reCaptchaRef = useRef(ReCAPTCHA);
    //#endregion variables

    //#region methods
    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'setErrorsDefault';
        try {
            setErrors(prev => ({ ...prev, email: '', password: '' }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const validateFormData = ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'validateFormData';
        try {
            let emailError = '';
            let passwordError = '';

            if (isUndNullEmp({ data: dataForm, subMethod: currentMethod })?.result) {
                emailError = messages?.thisFieldRequired?.[languageObj?.id];
                passwordError = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm.email, subMethod: currentMethod })?.result) {
                emailError = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            } else if (!isValidEmail({ data: dataForm.email })) {
                emailError = messages?.youMustEnterValidEmail[languageObj?.id];
                response.isWarning = true;
            }

            if (isUndNullEmp({ data: dataForm.password, subMethod: currentMethod })?.result) {
                passwordError = messages?.thisFieldRequired?.[languageObj?.id];
                response.isWarning = true;
            } else if (dataForm.password.trim().length < settings.passwords.minLength) {
                passwordError = messages?.youMustEnterValidPassword[languageObj?.id];
                response.isWarning = true;
            }

            setErrors(prev => ({ ...prev, email: emailError, password: passwordError }));
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const login = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'login';
        try {
            if (e) e?.preventDefault?.();

            //#region error default / validate data
            response = setErrorsDefault({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion error default / validate data

            setProcess(prev => ({ ...prev, login: true, showLoading: true }));
            setShowPassword(false);

            const reCaptchaToken = await reCaptchaRef?.current?.executeAsync();
            reCaptchaRef?.current?.reset();

            dataRequest = {
                email: dataForm.email,
                password: dataForm.password,
                rememberMe: dataForm.rememberMe,
                userDataSave: true,
                reCaptchaToken: reCaptchaToken,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            };

            response = await auth?.login(dataRequest);
            if (!response?.isSuccess || response?.isWarning) {
                response.urlGoTo = response?.urlGoTo === backend?.urls?.login ? '' : response?.urlGoTo;
                return;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            setProcess(prev => ({ ...prev, login: false, showLoading: false }));

            if (response?.isSuccess && !response?.isWarning) {
                localStorage.removeItem(settings.localStorage.redirectId);
                // history.push(previusObjUrl || '/');
                window.location.href = previusObjUrl || '/';
            }

            // CSN
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: response?.isSuccess
                });
            }
        }
    }

    const getData = async ({
        subMethod = '',
    } = {}) => {
        let response = getResponse({ type: 0 });
        const currentMethod = 'getData';
        try {
            setProcess(prev => ({ ...prev, showLoading: true }));

            //#region variables
            let notificationToastsData = [Toast?.getClass({}, false)];
            let notificationsToastObj = {
                ...NotificationToast?.getClass({}, false),
                controller: app?.views?.accounts?.accounts,
                method: app?.views?.main?.login,
                isAuthenticated: false,
            };
            //#endregion variables

            //#region notificationtoast (get)
            response = await notificationsToastGetAsync({
                data: notificationsToastObj,
                languageId: languageObj?.id,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                response.urlGoTo = response?.urlGoTo === backend?.urls?.login ? '' : response?.urlGoTo;
                return;
            }

            notificationToastsData = response?.result?.toasts || [];
            //#endregion notificationtoast (get)

            //#region set data form
            setDataForm(prev => (LoginRequest?.getClass()));
            //#endregion set data form

            //#region show toasts
            response = await notificationsToastShowAsync({
                data: notificationToastsData,
                languageId: languageObj?.id,
                window: window,
                document: document,
                subMethod: currentMethod,
            });

            if (!response?.isSuccess || response?.isWarning) {
                response.urlGoTo = response?.urlGoTo === backend?.urls?.login ? '' : response?.urlGoTo;
                return;
            }
            //#endregion show toasts

        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount?.current) return;

            if (!response?.isSuccess || response?.isWarning) {
                setShowData(false);
            }
            setProcess(prev => ({ ...prev, showLoading: false }));

            // CSN
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth,
                    languageId: languageObj?.id,
                    setShowData,
                    showDataValue: false
                });
            }
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => {
            isMount.current = false;
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    //#endregion methods

    return (
        <div>
            <Menu viewName={app?.views?.main?.home} />

            <div className='content-wrapper bg-transparent'>

                {/* Content Header (Page header) */}
                <div className='content-header'>
                    <div className='container-fluid'>
                        <div className='row mb-2 align-items-center bg-white p-3 rounded shadow-lg mx-0'>
                            <div className='col-sm-6'>
                                <h4 className='m-0 font-weight-bold text-dark'>{labels?.login?.[languageObj?.id]}</h4>
                            </div>
                            <div className='col-sm-6'>
                                <ol className='breadcrumb float-sm-right bg-transparent mb-0'>
                                    <li className='breadcrumb-item'><a href='/'>{labels?.home?.[languageObj?.id]}</a></li>
                                    <li className='breadcrumb-item active text-primary'>{labels?.login?.[languageObj?.id]}</li>
                                </ol>
                            </div>
                        </div>
                    </div>
                </div>
                {/* /.content-header */}

                {/* Main content */}
                <section className='content'>
                    <div className='container-fluid'>
                        {showData ? (
                            <div>
                                {/* <div className='row mb-4'>
                                    <div className='col-12'>
                                        <div className='alert alert-light border-0 shadow-lg rounded-lg d-flex align-items-center' role='alert'>
                                            <div className='mr-3 text-info'>
                                                <i className='fas fa-info-circle fa-2x'></i>
                                            </div>
                                            <div className='text-muted small'>
                                                <div className='mb-1'>
                                                    {messages?.loginFormParagraph1?.[languageObj?.id]} <a id={controls?.urls?.requestAccount?.id} href={process?.login ? urlStop : backend?.urls?.requestAccount} className='font-weight-bold text-primary'>{labels?.requestAccount?.[languageObj?.id]}</a>
                                                </div>
                                                <div>
                                                    {messages?.loginFormParagraph2?.[languageObj?.id]} <a id={controls?.urls?.requestAccountMonitor?.id} href={process?.login ? urlStop : backend?.urls?.requestAccountMonitor} className='font-weight-bold text-primary'>{labels?.monitorRequest?.[languageObj?.id]}</a>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='login-box' style={styles?.loginBox}>

                                            <div className={settings?.html?.cards?.default} style={{ borderRadius: '10px' }}>
                                                <LoadingSection alt='loadingSection'
                                                    className='overlay dark text-white'
                                                    height={20}
                                                    hidden={!process?.showLoading}
                                                    width={20}
                                                    languageId={languageObj?.id}
                                                    subMethod={currentMethod} />

                                                {/*Header*/}
                                                <div className='card-header border-bottom-0 pt-4 px-4 bg-white'>
                                                    <div className='d-flex align-items-center w-100'>
                                                        <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                                                            style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                                            <img src={images?.icons?.user} alt='UserLogin' style={styles?.cardHeaderLogo} />
                                                        </div>
                                                        <div className='d-flex flex-column'>
                                                            <h5 className='mb-0 font-weight-bold text-dark'>{labels?.login?.[languageObj?.id]}</h5>
                                                            <div className='mt-1'>
                                                                <span className='badge badge-pill badge-info px-2 py-1 text-uppercase' style={settings?.html?.badges?.micro}>
                                                                    <i className={`${icons?.fasFa?.user} mr-1`}></i> {labels?.signInToStartYourSession?.[languageObj?.id] || 'SIGN IN'}
                                                                </span>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <form onSubmit={(e) => login({ e: e, subMethod: 'form' })}>
                                                    {/*Body*/}
                                                    <div className='card-body px-4'>
                                                        <div className='form-group mb-4'>
                                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                <i className={`${icons?.envelope} mr-1`} /> {labels?.email?.[languageObj?.id]}
                                                            </small>
                                                            <input autoFocus
                                                                id={controls?.inputs?.email?.id}
                                                                autoComplete='username'
                                                                className='form-control form-control-lg bg-light border-0 shadow-sm text-dark'
                                                                style={{ borderRadius: '5px' }}
                                                                maxLength={dataFormLength?.max?.email}
                                                                onChange={(e) => setDataForm(prev => ({ ...prev, email: e?.target?.value }))}
                                                                onFocus={() => setErrors(prev => ({ ...prev, email: '' }))}
                                                                readOnly={process?.login}
                                                                value={dataForm?.email || ''}
                                                                placeholder={labels?.email?.[languageObj?.id]}
                                                                title={labels?.email?.[languageObj?.id]} />
                                                            <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.email || '')}</div>
                                                        </div>

                                                        <div className='form-group mb-4'>
                                                            <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                                                <i className={`${icons?.fasFa?.eyeSlash} mr-1`} /> {labels?.password?.[languageObj?.id]}
                                                            </small>
                                                            <div className='input-group shadow-sm' style={{ borderRadius: '5px', overflow: 'hidden' }}>
                                                                <input id={controls?.inputs?.password?.id}
                                                                    autoComplete='current-password'
                                                                    className='form-control form-control-lg bg-light border-0 text-dark'
                                                                    maxLength={dataFormLength?.max?.password}
                                                                    onChange={(e) => setDataForm(prev => ({ ...prev, password: e?.target?.value, }))}
                                                                    onFocus={() => setErrors(prev => ({ ...prev, password: '' }))}
                                                                    readOnly={process?.login}
                                                                    value={dataForm?.password || ''}
                                                                    type={showPassword ? 'text' : 'password'}
                                                                    placeholder={labels?.password?.[languageObj?.id]}
                                                                    title={labels?.password?.[languageObj?.id]} />
                                                                <div className='input-group-append'>
                                                                    <button className='btn bg-light border-0 text-muted shadow-none'
                                                                        type='button'
                                                                        disabled={process?.login}
                                                                        onClick={() => setShowPassword(!showPassword)}>
                                                                        <i className={showPassword ? icons?.fasFa?.eye : icons?.fasFa?.eyeSlash} />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                            <div className='form-text text-danger mt-1' style={styles?.inputMsgAlert}>{parse(errors?.password || '')}</div>
                                                        </div>

                                                        <div className='mb-4 mt-2'>
                                                            <div className='d-flex flex-column align-items-start px-2 py-2'
                                                                style={{ borderRadius: '8px', background: 'rgba(0,0,0,0.02)' }}>
                                                                <label className='d-flex align-items-center mb-2' style={{ cursor: process?.login ? 'default' : 'pointer', gap: '10px' }}
                                                                    htmlFor={controls?.checkBox?.remenberMe?.id}>
                                                                    <span className='position-relative' style={{ display: 'inline-block' }}>
                                                                        <input id={controls?.checkBox?.remenberMe?.id}
                                                                            type='checkbox'
                                                                            disabled={process?.login}
                                                                            onChange={(e) => setDataForm(prev => ({ ...prev, rememberMe: e?.target?.checked, }))}
                                                                            style={{ width: '16px', height: '16px', cursor: process?.login ? 'default' : 'pointer', accentColor: '#007bff' }} />
                                                                    </span>
                                                                    {/* <span className='text-muted font-weight-bold' style={{ fontSize: '0.82rem', userSelect: 'none' }}> */}
                                                                    <span className='text-muted font-weight-bold' style={{ userSelect: 'none' }}>
                                                                        {labels?.rememberMe?.[languageObj?.id]}
                                                                    </span>
                                                                </label>

                                                                <a id={controls?.urls?.forgotYourPassword.id}
                                                                    href={process?.login ? urlStop : backend?.urls?.recoverPassword}
                                                                    className='text-primary font-weight-bold mb-2'
                                                                    // style={{ fontSize: '0.82rem', textDecoration: 'none', transition: 'opacity 0.2s', opacity: process?.login ? 0.5 : 1 }}>
                                                                    style={{ textDecoration: 'none', transition: 'opacity 0.2s', opacity: process?.login ? 0.5 : 1 }}>
                                                                    {/* <i className={`${icons?.fasFa?.lock} mr-1`} style={{ fontSize: '0.75rem' }} /> */}
                                                                    <i className={`${icons?.fasFa?.lock} mr-1`} style={{}} />
                                                                    {labels?.forgotYourPassword?.[languageObj?.id]}
                                                                </a>

                                                                <a id={controls?.urls?.requestAccount?.id} href={process?.login ? urlStop : backend?.urls?.requestAccount} className='font-weight-bold text-primary mb-2'>
                                                                    <i className={`${icons?.fasFa?.userPlus}`} style={{}} /> {labels?.requestAccount?.[languageObj?.id]}
                                                                </a>
                                                                <a id={controls?.urls?.requestAccountMonitor?.id} href={process?.login ? urlStop : backend?.urls?.requestAccountMonitor} className='font-weight-bold text-primary'>
                                                                    <i className={`${icons?.fasFa?.search}`} style={{}} /> {labels?.monitorRequest?.[languageObj?.id]}
                                                                </a>
                                                            </div>

                                                        </div>

                                                    </div>

                                                    {/*Footer*/}
                                                    <div className='card-footer border-top-0 pt-3 pb-4 px-4 bg-white'>
                                                        <div className='d-flex justify-content-center w-100'>
                                                            <button id={controls?.buttons?.login?.id}
                                                                title={labels?.login?.[languageObj?.id]}
                                                                data-toggle='tooltip'
                                                                type='submit'
                                                                disabled={process?.login}
                                                                style={{ borderRadius: '5px' }}
                                                                className={controls?.buttons?.login?.defaultClass}>
                                                                {!process?.login ? (
                                                                    <i id={controls?.icons?.login.id} className={`${icons?.powerOff}`} />
                                                                ) : (
                                                                    <span id={controls?.spiners?.login.id} className={`${settings?.react?.html?.spinner?.borderSm}`} aria-hidden='true'></span>
                                                                )} {labels?.signIn[languageObj?.id]}
                                                            </button>
                                                            <a id={controls?.buttons?.home?.id}
                                                                href={process?.login ? urlStop : '/'}
                                                                title={labels?.home?.[languageObj?.id]}
                                                                style={{ borderRadius: '5px' }}
                                                                className={controls?.buttons?.home?.defaultClass}>
                                                                <i className={`${icons?.home}`} /> {labels?.home?.[languageObj?.id]}
                                                            </a>
                                                        </div>
                                                    </div>
                                                </form>

                                                <div>
                                                    <ReCAPTCHA className='g-recaptcha'
                                                        hl={languageObj?.id}
                                                        ref={reCaptchaRef}
                                                        sitekey={settings?.react?.reCAPTCHA?.reCAPTCHASiteKey}
                                                        size='invisible' />
                                                </div>
                                            </div>

                                        </div>

                                        <div className='text-muted text-center text-small'>
                                            <p>
                                                <small>
                                                    {labels?.protectedByReCAPTCHA?.[languageObj?.id]} - <a id={controls?.urls?.reCaptchaPrivaciConditions?.id}
                                                        target={process?.login ? '' : '_blank'}
                                                        href={process?.login ? urlStop : settings?.react?.reCAPTCHA?.urlPrivaciConditions}
                                                        rel='noreferrer'>{labels?.privacyAndConditions?.[languageObj?.id]}
                                                    </a>
                                                </small>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <div></div>
                        )}
                    </div>
                </section>

            </div>
        </div>
    )
}